/**
 * Scroll suave a un elemento por id, sin que el scroll-snap de la pagina
 * (html { scroll-snap-type: y proximity }, ver index.css) lo intercepte.
 *
 * El snap va "corrigiendo" un scroll programatico smooth de larga distancia
 * de vuelta hacia la seccion de origen antes de que avance -el boton
 * "Contactanos" del navbar dejaba de llevar al formulario por esto mismo,
 * ver App.tsx-. Restaurar el snap en el evento "scrollend" (en vez de un
 * timeout fijo) resulto fragil: Chrome puede emitir ese evento de forma
 * prematura -por el recalculo de layout al desactivar el snap, no por un
 * scroll real completado-, reactivandolo a mitad de un scroll largo.
 *
 * Compartida entre App.tsx (scroll a #contacto al navegar con hash desde
 * otra pagina) y cualquier CTA que scrollee a una seccion DENTRO de la misma
 * pagina (p.ej. el formulario de la landing de Automatizaciones).
 */
export function scrollToSection(sectionId: string): void {
  const target = document.getElementById(sectionId);
  if (!target) return;

  const html = document.documentElement;
  const previousSnap = html.style.scrollSnapType;
  html.style.scrollSnapType = "none";

  target.scrollIntoView({ behavior: "smooth" });

  window.setTimeout(() => {
    html.style.scrollSnapType = previousSnap;
  }, 1500);
}
